import MapElementProps from "../MapElementProps";

import './MapStyleControl.scss';
import {useAppSelector} from "../../../redux/hooks";
import {selectLocationAccessAllowed} from "../../../redux/features/location/slice";
import MapIControl from "./MapIControl";
import { t } from "../../../i18n";

const AllowLocationAccessControl = ({map}: MapElementProps) => {
    const locationAccessAllowed: boolean | undefined = useAppSelector(selectLocationAccessAllowed);
    return (
        <MapIControl map={map!} position='top-left' doShow={() => locationAccessAllowed === false}>
            <div className="error-control">
                {t('web.map.allowLocationAccess')}
            </div>
        </MapIControl>
    );
}

export default AllowLocationAccessControl;